import React from "react";
import ApplyNowButton from "../../../../../components/applynowbutton";

const OutcomesAIR = () => {
  return (
    <div
      className="py-10 mt-5 rounded-lg bg-gray-900 text-white relative"
      id="outcomes"
    >
      <div className="absolute inset-0 bg-black bg-opacity-50 z-10 rounded-lg"></div>

      <div className="h-full flex items-center justify-center relative z-20 px-10 text-center">
        <div className="max-w-4xl">
          <h2 className="md:text-3xl text-lg font-bold mb-4">
            MA in Diplomacy and International Relations Option
          </h2>
          <div className="bg-sdorange h-1 w-10 mx-auto mb-4"></div>

          <p className="md:text-lg text-base leading-relaxed text-justify">
            Graduates can progress to the MA in Diplomacy and International
            Relations (90 ECTS). This advanced degree builds upon the
            Postgraduate Diploma, offering in-depth exploration of global
            politics, advanced diplomatic strategies, and innovative research
            methodologies, paving the way for academic and professional
            excellence in international relations.
          </p>
        </div>
      </div>
      <div
        className="absolute inset-0 bg-cover bg-center rounded-lg"
        style={{ backgroundImage: "url('/image-fix/random-images/r3.jpg')" }}
      ></div>
      <ApplyNowButton />
    </div>
  );
};

export default OutcomesAIR;
